import React, { useEffect, useState } from 'react';
import { Dialog, Snackbar } from '@mui/material';
import useStyles from './useStyles';
import { withScoutTheme } from '../ThemeContext/ThemeContext';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
import axios from 'axios';
import queryString from 'query-string';
import Messenger from './components/Messenger';
import SelectRecipients from './components/SelectRecipients';

function TextUsModal({ applicationId, job, open }) {
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState(null);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [isGroupMessage, setIsGroupMessage] = useState(false);
  const [isSelectModalOpen, setIsSelectModalOpen] = useState(false);
  const [statuses, setStatuses] = useState([]);
  const [largeModal, setLargeModal] = useState(true);
  const [isOpen, setIsOpen] = useState(open);
  const [snack, setSnack] = useState(null);

  const classes = useStyles();
  const token = document.querySelector('meta[name="csrf-token"]').content;
  const config = {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': token
    }
  };

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    const toggleTextusModal = (e) => {
      if (!e.target.classList.contains('toggle-textus-btn')) return;
      e.preventDefault();
      setIsGroupMessage(e.target.dataset.isSelectModalOpen === 'true');
      openModal();
    };
    document.addEventListener('click', toggleTextusModal);
    return () => document.removeEventListener('click', toggleTextusModal);
  }, [isOpen]);

  useEffect(() => {
    async function getData() {
      setLargeModal(true);
      setLoading(true);
      try {
        const { data } = await axios.get(`/admin/jobs/${job.id}/applications/`, {
          ...config,
          params: { application_ids: applicationId },
          paramsSerializer: (params) => queryString.stringify(params, { arrayFormat: 'bracket' })
        });
        setApplications(data.applications);
        if (isGroupMessage) {
          setIsSelectModalOpen(true);
        } else {
          setIsSelectModalOpen(false);
          setSelectedApplications(data.applications);
        }
        setStatuses([
          {
            id: null,
            state: 'new',
            name: 'New',
            colour: ''
          },
          ...data.statuses
        ]);
      } catch (e) {
        setSnack('Could not fetch applicant data');
      } finally {
        setLoading(false);
      }
    }
    getData();
  }, [isGroupMessage, isOpen]);

  if (loading)
    return <ReactLoading type="spin" color={'#004E70'} width={45} className={classes.loading} />;

  return (
    <React.Fragment>
      <Dialog
        disableEnforceFocus
        fullWidth={true}
        open={isOpen}
        onClose={closeModal}
        classes={{ paper: `${classes.modalRoot} ${largeModal ? classes.modalLarge : ''}` }}
      >
        {isSelectModalOpen ? (
          <SelectRecipients
            statuses={statuses}
            applications={applications}
            setSelectedApplications={setSelectedApplications}
            setIsSelectModalOpen={setIsSelectModalOpen}
          />
        ) : (
          <Messenger
            job={job}
            statuses={statuses}
            applications={applications}
            selectedApplications={selectedApplications}
            setSelectedApplications={setSelectedApplications}
            setLargeModal={setLargeModal}
            closeModal={closeModal}
            setSnack={setSnack}
            isGroupMessage={isGroupMessage}
            setIsGroupMessage={setIsGroupMessage}
            token={token}
            config={config}
          />
        )}
      </Dialog>
      <Snackbar open={snack} onClose={() => setSnack(null)} message={snack} />
    </React.Fragment>
  );
}

TextUsModal.propTypes = {
  applicationId: PropTypes.number,
  job: PropTypes.object.isRequired,
  isSelectModalOpen: PropTypes.bool
};

export default withScoutTheme(TextUsModal);
